module.exports = __webpack_public_path__ + "img/next.bff7c733.png";